import { render, staticRenderFns } from "./bind-distributor.vue?vue&type=template&id=12ee2336&scoped=true&"
import script from "./bind-distributor.vue?vue&type=script&lang=js&"
export * from "./bind-distributor.vue?vue&type=script&lang=js&"
import style0 from "./bind-distributor.vue?vue&type=style&index=0&id=12ee2336&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee2336",
  null
  
)

export default component.exports